<template>
  <div class="ag-page_alertcs position-relative">
    <ag-card :module="module"></ag-card>
    <ag-otp-modal :status="otpStatus" :selected-computer="selectedComputer"></ag-otp-modal>
  </div>
</template>

<script>
import { defineAsyncComponent, defineComponent, ref } from "vue";
import AgCard from "@/components/ag-card/index.vue";
import AgOtpModal from "@/components/ag-otp-modal/index.vue";
import ComputerList from "@/helpers/pages/ComputerList";
import moment from "moment";
import Swal from "sweetalert2";
import { useStore } from "@/store";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "ComputerList",
  setup() {
    const route = useRoute();
    const module = ref(ComputerList);
    const breadcrumbComponent = defineAsyncComponent(() =>
      import("@/views/pages/Assets/AssetBreadcrumb.vue")
    );
    const store = useStore();
    const setFilterStatus = () => {
      store.dispatch(GeneralActionTypes.FILTER_STATUS, false);
    };
    let filter = ref({
      page: 1,
      limit: 10,
    });

    const RESETFILTER = filter;
    const getList = (
      filters = filter.value,
      options = module.value.component.options
    ) => {
      filters.groupGuids = [route.params.groupGuid];
      filters.computer = "";
      const body = { filters, options };
      store.dispatch(GeneralActionTypes.GET_ASSET_COMPUTERS, body);
    };

    const searchWithFilters = (param) => {
      filter.value.endDate = moment().utc().format("YYYY-MM-DD HH:mm");
      filter.value.page = module.value.component.options.page || 0;
      filter.value.limit = module.value.component.options.pageSize || 5;

      const filters = filter.value;
      const options = module.value.component.options;
      module.value.readyToUseFilters = filters;
      getList(filters, options);
    };

    const resetFilters = () => {
      searchWithFilters(true);
    };

    const deleteFunction = function (id) {
      Swal.fire({
        title: "Delete Computer?",
        icon: "warning",
        text: "You are about to delete the selected computer. Do you want to delete ?",
        showCancelButton: true,
        confirmButtonText: "Delete",
      }).then((result) => {
        if (result.isConfirmed) {
          store
            .dispatch(GeneralActionTypes.DELETE_ASSET_COMPUTERS, id)
            .then((response) => {
              if (response.isSuccess) {
                getList();
              }
              if (Number(response.statusCode) != 200) {
                Swal.fire("Error", response.Errors, "error");
              } else {
                Swal.fire(
                  "Deleted!",
                  "The Computer has been deleted.",
                  "success"
                );
              }
            })
            .catch((e) => {
              Swal.fire("Error", JSON.stringify(e.Message), "error");
            });
        }
      });
    };

    return {
      setFilterStatus,
      searchWithFilters,
      resetFilters,
      filter,
      deleteFunction,
      getList,
      module,
      breadcrumbComponent,
    };
  },
  mounted() {
    this.setFilterStatus();
    const filters = this.filter;
    this.module.readyToUseFilters = filters;
    const options = this.module.component.options;
    this.getList(filters, options);
  },
  components: { AgCard, AgOtpModal },
  data() {
    return {
      loading: false,
      otpStatus: false,
      selectedComputer: {
        ComputerId: "",
      },
    };
  },
  methods: {
    otpFunction(data) {
      this.otpStatus = true;
      this.selectedComputer = data;
    },
  },
});
</script>

<style>
.ag-card_buttons {
  align-items: center;
}
.ag-card_buttons .ag-button {
  height: 37px;
  background: #164b6c;
}
</style>
